<!--<template>
  <div>
    <ImsTemplate ref="template" :formParams="templateInfo" :opCode="opCode"></ImsTemplate>
    <ImsTemplate v-if='uOg==0' ref="serviceProfile" :formParams="serviceProfileInfo" :opCode="opCode"></ImsTemplate>
    <ImsTemplate v-if='uOg==0' ref="supplementary" :formParams="supplementaryInfo" :opCode="opCode"></ImsTemplate>
    <ImsTemplate v-if='uOg==1' ref="grpprofileInfo" :formParams="grpprofileInfo" :opCode="opCode"></ImsTemplate>
  </div>
</template>-->

<template>
  <div class="h-dialogContainer">
    <div class="h-borderBox">
      <div class="h-borderBox-top" style="height: 40px; background-color: #d9d9d9;margin-bottom:10px;">{{$t('SubscriberIms.templateinfDiv')}}</div>
      <div class="">
        <template>
          <ImsTemplate ref="template" :formParams="templateInfo" :opCode="opCode"></ImsTemplate>
        </template>
      </div>
    </div>
    <div v-if='showSubInfo' class="h-borderBox" >
      <div v-if='showSubInfo' class="h-borderBox-top" style="height: 40px; background-color: #d9d9d9;margin-bottom:10px;">{{$t('SubscriberIms.subInfoDiv')}}</div>
      <div class="">
        <template>
          <ImsTemplate v-if='showSubInfo' ref="subInfo" :formParams="subInfo" :opCode="opCode"></ImsTemplate>
        </template>
      </div>
    </div>
    <div v-if='uOg==0' class="h-borderBox" >
      <div v-if='uOg==0' class="h-borderBox-top" style="height: 40px; background-color: #d9d9d9;margin-bottom:10px;">{{$t('SubscriberIms.serviceProfileInfoDiv')}}</div>
      <div class="">
        <template>
          <ImsTemplate v-if='uOg==0' ref="serviceProfile" :formParams="serviceProfileInfo" :opCode="opCode"></ImsTemplate>
        </template>
      </div>
    </div>
    <div v-if='uOg==0' class="h-borderBox">
      <div v-if='uOg==0' class="h-borderBox-top" style="height: 40px; background-color: #d9d9d9;margin-bottom:10px;">{{$t('SubscriberIms.supplementaryInfoDiv')}}</div>
      <div class="">
        <template>
          <ImsTemplate v-if='uOg==0' ref="supplementary" :formParams="supplementaryInfo" :opCode="opCode"></ImsTemplate>
        </template>
      </div>
    </div>
    <div v-if='uOg==1' class="h-borderBox">
      <div v-if='uOg==1' class="h-borderBox-top" style="height: 40px; background-color: #d9d9d9;margin-bottom:10px;">{{$t('SubscriberIms.groupProfileInfoDiv')}}</div>
      <div class="">
        <template>
          <ImsTemplate v-if='uOg==1' ref="grpprofileInfo" :formParams="grpprofileInfo" :opCode="opCode"></ImsTemplate>
        </template>
      </div>
    </div>
    <div v-if='uOg==1 && showAdditionFlag' class="h-borderBox">
      <div v-if='uOg==1' class="h-borderBox-top" style="height: 40px; background-color: #d9d9d9;margin-bottom:10px;">{{$t('SubscriberIms.tgrpadditionalDiv')}}</div>
      <div class="">
        <template>
          <ImsTemplate v-if='uOg==1' ref="grpAdditionInfo" :formParams="grpAdditionInfo" :opCode="opCode"></ImsTemplate>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import ImsTemplate from "./ImsTemplate";
import SubscriberTool from '../../util/parseFormNew/tools/subscriberTool';
import mixin from '../../../../mixin/mixin';

export default {
  name: "AddTemplateDialog",
  mixins: [mixin],
  props: {
    opCode: { type: String, default: "" },
    neversion: { type: String, default: "" },
    neid: { type: Number, default: 0 },
  },
  data() {
    return {
      templateInfo: {
        json: "",
        formId: this.opCode + "templateInfo",
        subObject: "",
        modelName: "templateInfo" // modelName需要与返回请求的groupBy字段匹配(展示分区)
      },
      subInfo: {
        json: "",
        formId: this.opCode + "subInfo",
        subObject: "",
        modelName: "subinfo"
      },
      serviceProfileInfo: {
        json: "",
        formId: this.opCode + "serviceProfileInfo",
        subObject: "",
        modelName: "serviceProfileInfo"
      },
      supplementaryInfo: {
        json: "",
        formId: this.opCode + "supplementaryInfo",
        subObject: "",
        modelName: "supplementaryInfo"
      },
      grpprofileInfo: {
        json: "",
        formId: this.opCode + "grpprofileInfo",
        subObject: "",
        modelName: "grpprofileInfo"
      },
      grpAdditionInfo: {
        json: "",
        formId: this.opCode + "grpAdditionInfo",
        subObject: "",
        modelName: "grpAdditionInfo",
      },
      templateUrl: "/lte/ems/subscriber/imsunms/getParamJson",
      msgid: 'impuinfo_template',
      uOg: 0,
      showAdditionFlag: false
    };
  },
  methods: {
    mainHandler(data = []) {
      // data为编辑按钮传入的数据
      const $this = this;
      let arrBase = null;
      let arrSub = null;
      let arrData = null;
      let arrSup = null;
      let arrGrp = null;
      let arrAddition = null;
      const params = {
        msgid: this.msgid,
        neid: this.neid
      }
      this.$axios.post(this.templateUrl, params).then(response => {
        // 获取模板请求
        const res = response.data.resultVal;
        const sub = new SubscriberTool();
        const resultMap = sub.$devideByGroupBy(res, data);

        arrBase = resultMap.get($this.templateInfo.modelName);
        $this.templateInfo = arrBase;

        arrSup = resultMap.get($this.supplementaryInfo.modelName);

        // 因开户与模板不同,Excel只能保留开户,模板由前端代码做处理
        arrSup &&　arrSup.map((item) => {
          if (item.id == 'htcfaddr' || item.id == 'realm') {
            item.couldMod = true;
            if (item.validate && item.validate.required) {
              const validate = { maxLength: item.validate.maxLength, regex: item.validate.regex };
              item.validate = validate;
            }
          }
        })
        $this.supplementaryInfo = arrSup;

        arrSub = resultMap.get($this.subInfo.modelName);
        $this.subInfo = arrSub;

        arrData = resultMap.get($this.serviceProfileInfo.modelName);
        $this.serviceProfileInfo = arrData;

        arrGrp = resultMap.get($this.grpprofileInfo.modelName);
        $this.grpprofileInfo = arrGrp;

        arrAddition = resultMap.get($this.grpAdditionInfo.modelName);
        $this.grpAdditionInfo = arrAddition;
        if (arrAddition) {
          $this.showAdditionFlag = true;
        }

      });
    },
    reMount() {
      this.$refs.supplementary.reMount();
      this.$refs.template.reMount();

      if(this.$refs.subInfo) {
        this.$refs.subInfo.reMount();
      }
/*
      this.$refs.subscriber.reMount();
*/
      this.$refs.serviceProfile.reMount();
      this.$refs.grpprofileInfo.reMount();
    },
    getDatas() {
      let validateReturn = new Boolean();
      if (this.uOg == 0){
        validateReturn =
        this.$refs.template.validateResult() &&
        this.$refs.serviceProfile.validateResult() &&
        this.$refs.supplementary.validateResult() &&
        (this.$refs.subInfo ? this.$refs.subInfo.validateResult() : true);
      } else {
        validateReturn =
        this.$refs.template.validateResult() &&
        this.$refs.grpprofileInfo.validateResult() &&
        (this.$refs.grpAdditionInfo ? this.$refs.grpAdditionInfo.validateResult() : true);
      }
      if (!validateReturn) {
        console.log("表单验证不通过");
        return null;
      }

      let templateMap = this.$refs.template.getDatas();
      if (this.uOg == 0) {
        const additionMap = this.$refs.serviceProfile.getDatas();
        const supMap = this.$refs.supplementary.getDatas();

        for (const [key, value] of additionMap.entries()) {
          templateMap.set(key, value);
        }
        for (const [key, value] of supMap.entries()) {
          templateMap.set(key, value);
        }
        if (this.$refs.subInfo) {
          const subInfoMap = this.$refs.subInfo.getDatas();
          for (const [key, value] of subInfoMap.entries()) {
            templateMap.set(key, value);
          }
        }
        templateMap.set('temptype', 1);
      } else {
        const grpprofileMap = this.$refs.grpprofileInfo.getDatas();
        for (const [key, value] of grpprofileMap.entries()) {
          templateMap.set(key, value);
        }

        if (this.$refs.grpAdditionInfo) {
          const grpAdditionMap = this.$refs.grpAdditionInfo.getDatas();
          for (const [key, value] of grpAdditionMap.entries()) {
            templateMap.set(key, value);
          }
        }
        templateMap.set('temptype', 2);
      }
      const templateJson = this.getAnotherBussiness(templateMap);
      return templateJson;
    },
    getAnotherBussiness(map) {
      const json = {};
      const context = {};
      const tempJson = this.mapToJson(map);
      for (let key in tempJson) {
        if (key == 'tempname' || key == 'tempnum' || key == 'temptype' || key == 'neid') {
          json[key] = tempJson[key];
        } else {
          context[key] = tempJson[key];
        }
      }
      json['context'] = JSON.stringify(context);
      return json;
    },
    init(uOg) {
      this.uOg = uOg;
      if (uOg == 0){
        this.msgid = 'impuinfo_template';
      } else {
        this.msgid = 'tgroup_template';
      }
    },
  },
  components: {
    ImsTemplate
  },
  computed: {
    showSubInfo() {
      return this.uOg==0 && this.neversion.indexOf("_V22") > 0;
    },
  }
};
</script>
